import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { CustomCalloutsContainer } from './';
import CustomCalloutsErrorBoundary from './CustomCalloutsErrorBoundary';
import MarkdownRenderer from '../MarkdownRenderer';
import { publishCounterMetric } from '../../utils/metrics';

const CustomCalloutsMarkdown = ({ content, locale }) => {
  useEffect(() => {
    publishCounterMetric('CustomCallouts', {
      counterName: 'CustomCallout',
      additionalMetrics: {
        CalloutType: 'markdown',
      },
    });
  }, []);

  return content ? (
    <CustomCalloutsErrorBoundary>
      <CustomCalloutsContainer>
        <MarkdownRenderer
          locale={locale}
          markdown={decodeURIComponent(content)}
          theme="light"
        />
      </CustomCalloutsContainer>
    </CustomCalloutsErrorBoundary>
  ) : null;
};

CustomCalloutsMarkdown.propTypes = {
  content: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

export default CustomCalloutsMarkdown;
